import { styled } from '@attentive-platform/stem-ui';

export const FormContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  alignItems: 'center'
}));

export const InputContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
  alignItems: 'center',
  width: '100%'
}));

export const FlexItem = styled('div')(() => ({
  flex: 1
}));

export const ErrorText = styled('div')(() => ({
  color: 'var(--color-error-50)',
  fontWeight: 'bold'
}));

export const StyledBreakWordContainer = styled('div')(() => ({
  wordBreak: 'break-word' /* Standard */,
  overflowWrap: 'break-word',
  width: '100%'
}));

export const InfoText = styled('div')(() => ({
  padding: '10px 14px',
  borderRadius: '4px',
  margin: '10px 0',
  borderLeft: '3px solid #4a5568',
  backgroundColor: '#f7fafc'
}));
